import React, { Component } from 'react';
import PropTypes from 'prop-types';

import i18n from 'i18n-react';
import onClickOutside from 'react-onclickoutside';
import { HashLink as Link, NavHashLink as NavLink } from 'react-router-hash-link';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import DataHandler from 'config/DataHandler';
import StorageHandler from 'config/StorageHandler';

import { storageKeys } from 'settings';

class Dropdown extends Component {
  constructor(props) {
    super(props);

    this.state = {
      appId: -1,
      user: '',
      frame: null,
      profileImageHeader: '',
    };

    this.handleClickOutside = this.handleClickOutside.bind(this);
  }

  componentDidMount() {
    this.openSettings();
  }

  handleClickOutside() {
    const { handleClickOutside } = this.props;
    handleClickOutside();
  }

  openSettings() {
    const { appId, user } = this.state;

    StorageHandler.load(storageKeys.appInfo).then(({ profileImageHeader }) => {
      this.setState({
        profileImageHeader,
      });
    });

    StorageHandler.load(storageKeys.lang).then((lang) => {
      if (appId === -1 || user === '') {
        DataHandler.matchAppId().then((id) => {
          StorageHandler.load(storageKeys.user).then((userKey) => {
            const { email } = userKey;
            this.setState({
              appId: id,
              user: email,
              frame: `https://crm.travpromobile.com/profile/?header=false&email=${email}&app_id=${id}&lang=${lang.langFile}`,
            });
          });
        });
      } else {
        this.setState({
          frame: `https://crm.travpromobile.com/profile/?header=false&email=${user}&app_id=${appId}&lang=${lang.langFile}`,
        });
      }
    });
  }

  render() {
    const { email, firstName, lastName } = this.props;
    const { frame, profileImageHeader } = this.state;
    return (
      <div className="dropDown">
        <div className="dropDown__Header">
          <img className="dropDown__Header-background" src={`${profileImageHeader}?width=1024`} alt="profile" />
          <a className="dropDown__Header-profile" onClick={this.handleClickOutside}>
            <FontAwesomeIcon icon={['fas', 'user']} />
            {`${firstName} ${lastName}`}
            <br />
            <span>{email}</span>
          </a>
        </div>
        <div className="dropDown__Nav">
          <ul>
            <li>
              <button
                type="button"
                data-trigger="settings"
                data-fancybox-rel="settings"
                className="settings"
                href={frame}
              >
                {i18n.translate('nav.accountSettings')}
              </button>
            </li>
            <li>
              <NavLink onClick={this.handleClickOutside} activeClassName="is-active" to="/main/messages">
                {i18n.translate('nav.messages')}
              </NavLink>
            </li>
          </ul>
        </div>
        <div className="dropDown__Footer">
          <hr />
          <ul>
            <li>
              <NavLink onClick={this.handleClickOutside} activeClassName="is-active" to="/logout">
                <FontAwesomeIcon icon={['fas', 'sign-out-alt']} />
                {i18n.translate('general.logOut')}
              </NavLink>
            </li>
          </ul>
        </div>
        <div href={frame} data-fancybox="settings" data-type="iframe" className="settings" />
      </div>
    );
  }
}

export default onClickOutside(Dropdown);

Dropdown.propTypes = {
  firstName: PropTypes.string,
  lastName: PropTypes.string,
  // diploma: PropTypes.func,
  email: PropTypes.string,
  handleClickOutside: PropTypes.func,
  // unreadMessageCount: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  // trainingComplete: PropTypes.bool,
};

Dropdown.defaultProps = {
  firstName: 'Firstname',
  lastName: 'Lastname',
  email: 'user@email.com',
  // diploma: () => {},
  // unreadMessageCount: '',
  handleClickOutside: () => {
    this.setState({
      menuToggle: false,
    });
  },
  // trainingComplete: false,
};
